import { render } from "./LightboxPosterComponent.vue?vue&type=template&id=31002de7&scoped=true"
import script from "./LightboxPosterComponent.vue?vue&type=script&lang=ts"
export * from "./LightboxPosterComponent.vue?vue&type=script&lang=ts"

import "./LightboxPosterComponent.vue?vue&type=style&index=0&id=31002de7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31002de7"

export default script